import { EntityType } from '../../../../@Api/Model/Implementation/EntityType';
import { loadModuleDirectly } from '../../../../@Util/DependencyInjection/Injection/DependencyInjection';
import { RouterStore } from '../../../../@Service/Router/RouterStore';

export function openEntityTypeConfiguration(entityType: EntityType)
{
    return loadModuleDirectly(RouterStore).route(`/type/${entityType.id}/configuration/general`);
}
